module.exports = __webpack_public_path__ + "img/barunlaw.cd88a069.png";